import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { NAV_ITEMS, INSTAGRAM_URL } from './navItems';

export const DesktopNav = ({ pathname }) => (
  <nav className="nav-links" data-testid="desktop-nav">
    {NAV_ITEMS.filter(item => !item.mobileOnly).map(item => (
      <Link
        key={item.path}
        to={item.path}
        className={`nav-link ${pathname === item.path ? 'active' : ''}`}
        data-testid={`nav-link-${item.label.toLowerCase()}`}
      >
        {item.label}
      </Link>
    ))}
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="nav-link"
      data-testid="nav-instagram-link"
    >
      <Instagram className="w-5 h-5" />
    </a>
  </nav>
);
